import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=4bef1d24&scoped=true&"
import script from "./Popups.vue?vue&type=script&lang=js&"
export * from "./Popups.vue?vue&type=script&lang=js&"
import style0 from "./Popups.vue?vue&type=style&index=0&id=4bef1d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef1d24",
  null
  
)

export default component.exports